<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      {{ address.name }}
      <router-link class="btn btn-primary" :to="{ name: 'address-edit', params: { address_id: address.id }}">Редактировать адрес</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'district-details', params: { district_id: $route.params.district_id } }">← Назад к Адресам</router-link>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ address.name }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :address-id="address.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getAddress } from '@/services/address.service'
import helpers from '@/helpers'

export default {
  name: 'address-details',
  data () {
    return {
      address: {
        id: null,
        name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.address_id !== undefined) {
      this.address.id = this.$route.params.address_id

      getAddress(this.address.id).then((response) => {
        this.address = response.data
      })
    }
  },
  methods: {
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// AddressDetails.vue?0dc49446